import { render, staticRenderFns } from "./Shylock2Dialog.vue?vue&type=template&id=1778ebfc&scoped=true"
import script from "./Shylock2Dialog.vue?vue&type=script&lang=js"
export * from "./Shylock2Dialog.vue?vue&type=script&lang=js"
import style0 from "./Shylock2Dialog.vue?vue&type=style&index=0&id=1778ebfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1778ebfc",
  null
  
)

export default component.exports